const m = require('mithril');
const prop = require('mithril/stream');
const BasePlugin = require('./basePlugin');
const edit = require('../../layout/components/edit');
const loaders = require('../../layout/components/loaders');

const leafletFullScreen = require('leaflet-fullscreen');
const leafletFullScreenStyles = require('leaflet-fullscreen/dist/leaflet.fullscreen.css');

class FullscreenPlugin extends BasePlugin {
  constructor(ctrl) {
      super(ctrl);

      this.ctrl.eventBus.once('mithril:oncreate', () => {
        this.ctrl.mapIsFullscreen = prop(false);

        let newControl = new L.Control.Fullscreen({
          position: 'bottomright',
          pseudoFullscreen: true,
        })
        this.ctrl.map.whenReady(() => this.ctrl.map.addControl(newControl));
        this.ctrl.map.on('fullscreenchange', () => this.ctrl.mapIsFullscreen(!this.ctrl.mapIsFullscreen()));
      });
  }
}

module.exports = FullscreenPlugin;
